import type { DocIngestMeta } from '@axilon-apps/domains-ontology-ui-state'

import { Badge } from '../../components/ui/badge'

function formatIngestedAt(value: string): string {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  return date.toLocaleString()
}

const IngestionDetails = ({ meta }: { meta: DocIngestMeta }) => {
  const reviewLabel = meta.reviewStatus === 'processed' ? 'Processed' : 'Needs review'
  return (
    <div className="flex flex-col gap-2" data-testid="ingestion-details">
      <div className="text-11 uppercase tracking-wider text-ink-3">Ingestion details</div>
      <dl className="m-0 grid grid-cols-[auto_1fr] gap-x-4 gap-y-1.5 text-sm text-ink-2">
        <dt className="text-ink-3">Pipeline</dt>
        <dd className="m-0">{meta.pipeline}</dd>
        {meta.jobId !== undefined ? (
          <>
            <dt className="text-ink-3">Job</dt>
            <dd className="m-0 font-mono text-12">{meta.jobId}</dd>
          </>
        ) : null}
        <dt className="text-ink-3">Original file</dt>
        <dd className="m-0 font-mono text-12">{meta.originalFilename}</dd>
        <dt className="text-ink-3">Ingested</dt>
        <dd className="m-0">{formatIngestedAt(meta.ingestedAt)}</dd>
        <dt className="text-ink-3">Review</dt>
        <dd className="m-0">
          <Badge variant={meta.reviewStatus === 'processed' ? 'secondary' : 'outline'}>
            {reviewLabel}
          </Badge>
        </dd>
      </dl>
    </div>
  )
}

export default IngestionDetails
